// src/hooks/useFormatDate.ts - 언어별 날짜 포맷팅 훅
import { useTranslation } from '../i18n';

export const useFormatDate = () => {
  const { language } = useTranslation();

  const formatDate = (date: Date | string | undefined): string => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (language === 'ko') {
      return dateObj.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } else {
      return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  };

  const formatDateTime = (date: Date | string | undefined): string => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (language === 'ko') {
      return dateObj.toLocaleString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } else {
      return dateObj.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  };

  const formatRelativeTime = (date: Date | string | undefined): string => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffInMs = now.getTime() - dateObj.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    
    if (language === 'ko') {
      if (diffInDays === 0) return '오늘';
      if (diffInDays === 1) return '어제';
      if (diffInDays < 7) return `${diffInDays}일 전`;
      if (diffInDays < 30) return `${Math.floor(diffInDays / 7)}주 전`;
      return formatDate(date);
    } else {
      if (diffInDays === 0) return 'Today';
      if (diffInDays === 1) return 'Yesterday';
      if (diffInDays < 7) return `${diffInDays} days ago`;
      if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} weeks ago`;
      return formatDate(date);
    }
  };

  return {
    formatDate,
    formatDateTime,
    formatRelativeTime
  };
};